import Vue from 'vue'

class MultiplierHelper {
  static async load () {
    let endpoint = `${process.env.VUE_APP_API_DOMAIN}/multipliers`
    return Vue.prototype.$http.get(endpoint)
      .then(res => res.data)
      .catch(err => console.log(err))
  }
  static getById (id) {
    let current = {}
    let multipliers = JSON.parse(localStorage.getItem('multipliers'))

    if (multipliers !== null) {
      multipliers.map((item) => {
        if (item.affiliate_name.toLowerCase() === id.toLowerCase()) current = item
      })
    }

    return current
  }
}

export default MultiplierHelper
